<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-12-25 17:14:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/components/BottomBtn/index.vue
-->
<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-19 17:49:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/components/BottomBtn/index.vue
-->
<template>
  <div class="con">
    <!-- 有货时 -->
    <div v-if="true" class="pad_lr">
      <!-- icon -->
      <!-- <div class="font12 icon_list">
        <img
          src="@/assets/product/icon_service@2x.png"
          alt=""
          class="left_icon"
        />
        <div class="icon_name font10 font_weight400 colo087 line_height_14">
          客服
        </div>
      </div> -->
      <pharmacist />
      <!-- button -->
      <div class="btn_all">
        <div v-for="(item, index) in btnList" :key="index">
          <div
            v-if="item.name"
            :class="{ buy_now: item.isLightHeight, colof: item.isLightHeight }"
            class="font14 font_weight500 add_cart colo087"
            @click="clickBtn(item.name)"
          >
            {{ item.name }}
          </div>
        </div>

        <!-- <div
          class="right font14 font_weight500  colo087 add_cart"
          @click="cancelOrder"
        >
          取消订单
        </div>
        <div
          class="font14 font_weight500  colo087 add_cart"
          @click="applyRefund"
        >
          申请退款
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
const Pharmacist = () =>
  import("@/components/Pharmacist").then(m => m.default || m);
export default {
  components: {
    Pharmacist
  },
  props: {
    btnList: {
      type: Array,
      default() {
        return [];
      }
    },
    packageIndex: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    }
  },
  data() {
    return {};
  },
  // mounted() {
  //   console.log(this.item, 5656565656);
  // },
  methods: {
    // cancelOrder() {
    //   this.$emit("cancelOrder");
    // },
    // applyRefund() {
    //   this.$emit("applyRefund");
    // },
    // milkPlan() {
    //   this.$emit("milkPlan");
    // },
    clickBtn(name) {
      const { retailSubOrderList } = this.getUserOrder;
      let a = "";
      retailSubOrderList.forEach(item => {
        if (item.orderType === 1) {
          a = item.subOrderSn;
          return;
        }
      });
      this.$emit(
        "clickBtn",
        name,
        this.getUserOrder.orderSn,
        this.packageIndex,
        this.item.subOrderSn || a,
        this.item.spuId
      );
    }
  }
};
</script>
<style lang="less" scoped>
.con {
  background: #fff;
  margin-top: 12px;
  box-shadow: 0px -3px 6px -3px rgba(193, 200, 207, 0.5);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  .icon_list {
    padding-left: 4px;
    .left_icon {
      // display: block;
      width: 24px;
      height: 24px;
    }
  }
  .buy_now {
    background: linear-gradient(180deg, #e8caa1 0%, #bf9264 100%);
    box-shadow: -1px -1px 4px 0px rgba(255, 255, 255, 0.5);
    border-radius: 16px;
    line-height: 32px;
    width: 88px;
    margin-left: 10px;
    margin-top: 3px;
    border: 0 !important;
  }
  .add_cart {
    box-sizing: border-box;
    border-radius: 21px;
    border: 1px solid #000;
    line-height: 28px;
    width: 88px;
    margin-top: 3px;
    margin-left: 10px;
  }
  .mr {
    padding-left: 22px;
  }
  .pad_lr {
    display: flex;
    justify-content: space-between;
    padding: 9px 12px 12px;
    box-shadow: 3px 0px 6px -3px rgba(193, 200, 207, 0.5);
  }
  .btn_all {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
